module.exports = "<!--The content below is only a placeholder and can be replaced.-->\r\n<router-outlet></router-outlet>\r\n\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// D:/TMB/TMB/MYTMB.UI/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main